//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { LocalizationInfo } from './LocalizationInfo';
import { WebsiteBlockSignupFormRenderContextDisplayItem } from './WebsiteBlockSignupFormRenderContextDisplayItem';
import { WebsiteBlockLoginFormRenderContextDisplayItem } from './WebsiteBlockLoginFormRenderContextDisplayItem';
import { WebsiteBlockContactFormRenderContextDisplayItem } from './WebsiteBlockContactFormRenderContextDisplayItem';
import { WebsiteRenderMode } from './Enums';

export class WebsiteRenderContextDisplayItem extends ItemBase {
    Locale: string | null = null;
    LocalizationInformation: LocalizationInfo | null = null;
    RenderMode: WebsiteRenderMode = WebsiteRenderMode.Website;
    SchoolActive: boolean = false;
    SchoolIsMultiTeacher: boolean = false;
    WidgetSandboxed: boolean | null = null;
    SignupFormRenderContext: WebsiteBlockSignupFormRenderContextDisplayItem | null = null;
    LoginFormRenderContext: WebsiteBlockLoginFormRenderContextDisplayItem | null = null;
    ContactFormRenderContext: WebsiteBlockContactFormRenderContextDisplayItem | null = null;

    constructor(initializer?: Partial<WebsiteRenderContextDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsiteRenderContextDisplayItem";
}
